













































































































import { Component, Vue } from 'vue-property-decorator';

declare let apigClientFactory: any;

export default Vue.extend({
  data: () => {
    return {
        maxRating: 10,
        rating: 10,
        message: "",
        options: [] as any[],
        submissionId: "",
        error: false,
        submitting: false,
        isLoading: false,
        isCompleted: false,
        isLoadingValidated: true,
        isValidated: false
    };
  },
  methods: {
    generateOptions(){
        for(let i=this.maxRating; i>0; i--){
            this.options.push({
                item: i,
                name: i
            })
        }
    },
    onSubmit() {
      console.log('touch down!');
      let questionnaires: any[] = [
        {
            submissionId: this.submissionId,
            question: 'Score Rating?',
            answer: this.rating.toString()
        }
      ]
      this.submitting = true;
      this.error = false

      if(this.rating < 10 && !this.message){
        this.error = true;
        return;
      }

      if(this.rating < 10){
        questionnaires.push({
            submissionId: this.submissionId,
            question: 'Reason?',
            answer: this.message
        })
      }

      const params = {};
      const body = {
        questionnaire: questionnaires,
      };
      const additionalParams = {
      };

      const apigClient = apigClientFactory.newClient();
      this.isLoading = true;
      apigClient.apiV1QuestionnaireSendPost(params, body, additionalParams)
        .then((result: any) => {
          this.isCompleted = true;
        }).catch((err: any) => {
            console.log('gagal submit questionnaire. error: ' + err);
        });

    },
    isOpen(){
        const putParams = {};
        const putBody = {
            submissionId: this.submissionId,
        };
        const putAdditionalParams = {};

        const putApigClient = apigClientFactory.newClient();
        putApigClient.apiV1SmsOpenPut(putParams, putBody, putAdditionalParams)
        .then((result: any) => {
            console.log('1');
        }).catch((err: any) => {
            console.log('0');
        });
    },
    getValidated(){
        this.isLoadingValidated = true;
        this.isValidated = false;
        this.isCompleted = false;
        const apigClient = apigClientFactory.newClient();
        this.isLoading = true;
        const params = {
            submissionId: this.submissionId
        };
        const body = {};
        const additionalParams = {};

      apigClient.apiV1QuestionnaireGet(params, body, additionalParams)
        .then((result: any) => {
            this.isLoadingValidated = false;
            this.isLoading = false;
            this.isValidated = true;
            this.isCompleted = false;
            this.isOpen()
        }).catch((error: any) => {
            this.isLoadingValidated = false;
            if(error.status == 404){
                this.isValidated = false;
                this.isCompleted = false;
            }else if(error.status == 403){
                this.isValidated = true;
                this.isCompleted = true;
            }
        });      
    }
  },
  mounted() {
    this.generateOptions()
    const content = document.getElementById('content');
    if (content != null) {
        content.style.position = 'relative';
        content.style.minHeight = '70vh';
    }

    const footer = document.getElementById('footer');
    if (footer != null) {
        footer.style.bottom = '0';
        footer.style.position = 'relative';
        footer.style.width = '100%';
        footer.style.height = 'auto';
    }

    let params = this.$route.params;
    this.submissionId = params.submissionId;    
    this.getValidated()
  },
});
